type ErrorLike = string | { message?: string } | undefined;

type FieldLike = {
  state: {
    meta: {
      isTouched: boolean;
      isValid: boolean;
      errors: ErrorLike[];
    };
  };
};

export const getErrorProps = ({ state: { meta } }: FieldLike) => {
  let message: string | undefined;
  const [firstError] = meta.errors;

  if (typeof firstError === 'string') {
    message = firstError;
  } else if (
    firstError &&
    typeof firstError === 'object' &&
    'message' in firstError
  ) {
    message = firstError.message;
  }

  return {
    error: meta.isTouched && !meta.isValid,
    supportingText: meta.isTouched && !meta.isValid ? message : undefined,
  };
};
